import * as types from '../types';

/**
 * Action to show/hide the global activity indicator
 * @param {boolean} show - true to show loader, false to hide
 */
export const showActivityIndicator = (show = true) => ({
  type: types.SHOW_LOADER,
  payload: show
});

/**
 * Convenience function to show the loader
 */
export const showLoader = () => showActivityIndicator(true);

/**
 * Convenience function to hide the loader
 */
export const hideLoader = () => showActivityIndicator(false);
